import { Alert, Container, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';

/** The build has no Supabase settings (Netlify environment variables, PLAN §6.4). */
export function SetupProblem() {
  const { t } = useTranslation('dashboard');
  return (
    <Container size={560} py={60}>
      <Title order={1}>{t('setup.title')}</Title>
      <Alert color="red" mt="md">
        {t('setup.body')}
      </Alert>
    </Container>
  );
}
